<template>
  <div class="teacher-card">
    <div class="card-wrap" v-if="teacherData">
      <div class="image-wrapper" @click="goToTeacher">
        <img
          :src="teacherData.profile_photo"
          alt
          srcset
          v-if="teacherData.profile_photo"
        />
        <img
          src="/img/user-placeholder.png"
          alt
          srcset
          v-else
          @click="goToTeacher"
        />
      </div>
      <div class="name" @click="goToTeacher">{{ teacherData.name }}</div>
      <span class="subject" v-if="teacherData.subjects">{{
        teacherData.subjects[0]
      }}</span>
      <div class="ratings">
        <star-rating v-model="teacherData.rating" v-bind="starattribs" />
      </div>
      <follow-button
        v-if="getUserRole === 'student'"
        :teacherId="teacherData.teacher_id"
        :isFollowing="isFollowing"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FollowButton from "../buttons/FollowButton";

export default {
  name: "teacher-card",
  components: {
    FollowButton
  },
  data() {
    return {
      rating: 4,
      starattribs: {
        readOnly: true,
        starSize: 13,
        showRating: false,
        activeColor: "#faa30c"
      },
      isFollowing: false
    };
  },
  props: {
    teacherData: Object
  },
  methods: {
    goToTeacher() {
      this.$router.push({
        path: "/teacher",
        query: {
          teacherId: this.teacherData.teacher_id
        }
      });
    }
  },
  mounted() {
    if (this.$route.path === "/student/following") {
      this.isFollowing = true;
    } else if (this.isAuthenticated) {
      this.isFollowing = this.teacherData.isFollowing
        ? this.teacherData.isFollowing
        : false;
    } else {
      this.isFollowing = false;
    }
  },
  computed: {
    ...mapGetters("user", ["isAuthenticated", "getUserRole"]),
    ...mapGetters("teacher", ["getFollowingTeachers"])
  },
  watch: {
    isAuthenticated() {
      if (this.isAuthenticated && this.getFollowingTeachers.length !== 0) {
        const t = this.getFollowingTeachers.find(teacher => {
          return teacher.teacher_id === this.teacherData.teacher_id;
        });
        if (t) {
          this.isFollowing = true;
        } else {
          this.isFollowing = false;
        }
      }
    }
  }
};
</script>

<style></style>
